import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import {
	Dropdown, DropdownItem, NavItem, DropdownMenu, NavLink, DropdownToggle
} from 'reactstrap';
import axios from 'axios';

import { LoginContext } from '../ParadigmaLoginProvider';
import { CartContext } from '../ParadigmaCartProvider';

import LoginModal from './LoginModal.js';
import RegisterModal from './RegisterModal';
import ForgottenPasswordModal from './ForgottenPasswordModal.js';

import api from '../../api';
import apifunctions from '../../api/functions.js';

import { View } from '../../../TiendaConfig';

const LoginActionView = ({ id, text, onClick, hideIcon }) => (
	<NavLink id={id} className="cursor-pointer menu-usuario-icon" onClick={onClick}>
		{
			!!!hideIcon &&
			<i style={{ fontSize: "24px", paddingTop: "2px" }} className="fa fa-sign-in" aria-hidden="true"></i>
		}
		{" "}{text}
	</NavLink>
)

const LoggedActionView = ({ displayname, toggle, menuOpen, hideIcon }) => (
	<DropdownToggle tag="div" className="mx-2 menu-usuario-icon">
		{
			!!!hideIcon &&
			<i className="fa fa-user cursor-pointer" style={{ fontSize: "24px", paddingTop: "2px" }} aria-hidden="true"></i>
		}
	</DropdownToggle>
)

const NotLoggedComponent = (props) => {
	const [showLoginModal, setShowLoginModal] = useState(false);
	const [showRegisterModal, setShowRegisterModal] = useState(false);
	const [showForgotPassModal, setShowForgotPassModal] = useState(false);

	return (
		<div className="overflow-auto">
			<LoginActionView
				hideIcon={props.hideIcon ? props.hideIcon : false}
				text={props.text}
				onClick={() => setShowLoginModal(true)}
				id="OpenLoginModalBtn"
			/>
			<LoginModal
				showModal={showLoginModal}
				toggle={() => setShowLoginModal(!!!showLoginModal) & setShowRegisterModal(false) & setShowForgotPassModal(false)}
				openRegisterModal={() => setShowLoginModal(false) & setShowRegisterModal(true) & setShowForgotPassModal(false)}
				openForgotPasswordModal={() => setShowLoginModal(false) & setShowRegisterModal(false) & setShowForgotPassModal(true)}
			/>
			<RegisterModal
				showModal={showRegisterModal}
				toggle={() => setShowRegisterModal(!!!showRegisterModal) & setShowRegisterModal(false)}
				openLoginModal={() => setShowLoginModal(true) & setShowRegisterModal(false)}
			/>
			<ForgottenPasswordModal
				showModal={showForgotPassModal}
				toggle={() => setShowForgotPassModal(!!!showForgotPassModal) & setShowLoginModal(false)}
				openLoginModal={() => setShowLoginModal(true) & setShowForgotPassModal(false)}
			/>
		</div>
	);
}

const ListaDePreciosDownloadItem = (props) => {
	const [downloading, setDownloading] = useState(false);

	const downloadFile = (evt) => {
		evt.preventDefault();
		if (!downloading) {
			const failureCallback = () => setDownloading(false);
			const successCallback = (response) => {
				setDownloading(false);

				let fileName = response.headers["content-type"].split("=")[1];
				if (fileName) {
					let downloadLink = window.document.createElement('a');
					if (window.navigator.msSaveOrOpenBlob) {
						window.navigator.msSaveBlob(response.data, fileName);
					} else {
						downloadLink.href = window.URL.createObjectURL(new Blob([response.data]));
						downloadLink.download = fileName;
						document.body.appendChild(downloadLink);
						downloadLink.click();
						document.body.removeChild(downloadLink);
					}
				}
			};

			const headers = apifunctions.headers();
			headers["responseType"] = 'blob';

			setDownloading(true);

			axios.get(
				api.api.clientes.cliente.descargarFicheroListaPrecio,
				headers
			).then(successCallback).catch(failureCallback);
		}
	}

	return (
		<div onClick={downloadFile}>
			{
				downloading ? (
					<><i className="fa fa-spinner fa-spin" aria-hidden="true"></i> | Procesando</>
				) : (
					<><i className="fa fa-list-alt" aria-hidden="true"></i> | Descargar Lista de Precios</>
				)
			}
		</div>
	);
}

const DropdownMenuLoggedComponent = ({ logout, classNames, displayname, hideIcon }) => {
	const [menuOpen, setMenuOpen] = useState(false);
	const toggle = () => setMenuOpen(!menuOpen);

	return (
		<Dropdown
			className={`${classNames} nav-item header-login-menu menu-usuario cursor-pointer`}
			isOpen={menuOpen}
			toggle={toggle}
		>
			<LoggedActionView {...{ displayname, toggle, menuOpen, hideIcon }} />
			<DropdownMenu className="dropdown-menu-center">
				<DropdownItem className="dropdown-menu-header" header>{displayname}</DropdownItem>
				<DropdownItem divider />
				<Link className="dropdown-menu-perfil" component={DropdownItem} to="/tienda/cliente/perfil">
					<i className="fa fa-user"></i> | Editar Datos
				</Link>

				<DropdownItem className="dropdown-menu-descargar-lista">
					<ListaDePreciosDownloadItem className="" />
				</DropdownItem>

				<Link className="dropdown-menu-historial-compra" component={DropdownItem} to="/tienda/cliente/compras">
					<i className="fa fa-cart-arrow-down" aria-hidden="true"></i> | Historial de Compras
				</Link>
				<Link className="dropdown-menu-resumen-cuenta" component={DropdownItem} to="/tienda/cliente/resumencuenta">
					<i className="fa fa-credit-card" aria-hidden="true"></i> | Estado de Cuenta
				</Link>
				<DropdownItem className="dropdown-salir" onClick={logout}>
					<i className="fa fa-sign-out"></i> | Salir
				</DropdownItem>
			</DropdownMenu>
		</Dropdown>
	);
}

const MenuLoggedComponent = ({ logout, classNames }) => (
	<div className={classNames}>
		<NavItem className={`dropdown-menu-perfil`}>
			<Link className="nav-link" component={DropdownItem} to="/tienda/cliente/perfil">
				<i className="fa fa-user"></i> | Editar Datos
			</Link>
		</NavItem>
		<NavItem className={`nav-link cursor-pointer dropdown-menu-descargar-lista`}>
			<ListaDePreciosDownloadItem className="" />
		</NavItem>
		<NavItem className={`dropdown-menu-historial-compra`}>
			<Link className="nav-link" component={DropdownItem} to="/tienda/cliente/compras">
				<i className="fa fa-cart-arrow-down" aria-hidden="true"></i> | Historial de Compras
			</Link>
		</NavItem>
		<NavItem className={`dropdown-menu-resumen-cuenta`}>
			<Link className="nav-link" component={DropdownItem} to="/tienda/cliente/resumencuenta">
				<i className="fa fa-credit-card" aria-hidden="true"></i> | Estado de Cuenta
			</Link>
		</NavItem>
		<NavItem className={`dropdown-salir nav-link cursor-pointer`} onClick={logout}>
			<i className="fa fa-sign-out"></i> | Salir
		</NavItem>
	</div>
);

const LoggedComponent = (props) => {
	const { displayname, logout, classNamesDesktop, classNamesMobile, hideIcon } = props;
	return (
		<>
			<DropdownMenuLoggedComponent
				logout={logout}
				classNames={classNamesDesktop ? classNamesDesktop : ""}
				displayname={displayname}
				hideIcon={hideIcon ? hideIcon : false}
			/>
			<MenuLoggedComponent
				logout={logout}
				classNames={classNamesMobile ? classNamesMobile : ""}
			/>
		</>
	);
}

const LoginNavItem = (props) => (
	<CartContext.Consumer>
		{
			({ clear }) =>
				<LoginContext.Consumer>
					{
						({ logged, logout, displayname }) => (
							logged ? (
								<LoggedComponent
									className={props.className ? props.className : ""}
									displayname={displayname}
									classNamesDesktop={props.classNamesDesktop ? props.classNamesDesktop : ""}
									classNamesMobile={props.classNamesMobile ? props.classNamesMobile : ""}
									logout={() => logout(() => clear())}
								/>
							) : (
								<NavItem className={props.className ? props.className : ""}>
									<NotLoggedComponent
										text={props.text ? props.text : ""}
										hideIcon={props.hideIcon ? props.hideIcon : false}
									/>
								</NavItem>
							)
						)
					}
				</LoginContext.Consumer>
		}
	</CartContext.Consumer>
);

export default LoginNavItem;